
// import { useState, useRef } from "react";
// import { useParams } from "react-router-dom";
// import axios from "axios";
// import "../Styles/Documents.css";

// const Documents = () => {
//   const { token } = useParams(); // ✅ TOKEN FROM URL

//   const [pan, setPan] = useState(null);
//   const [gst, setGst] = useState(null);
//   const [loading, setLoading] = useState(false);

//   const panRef = useRef(null);
//   const gstRef = useRef(null);

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!token) {
//       alert("Invalid or expired document upload link");
//       return;
//     }

//     if (!pan || !gst) {
//       alert("Please upload both PAN and GST documents.");
//       return;
//     }

//     const formData = new FormData();
//     formData.append("panFile", pan); // ✅ must match multer
//     formData.append("gstFile", gst); // ✅ must match multer

//     try {
//       setLoading(true);

//       await axios.post(
//         `https://b2bbackendapi.mmstourism.com/api/b2/agency/upload-documents/${token}`,
//         formData,
//         {
//           headers: {
//             "Content-Type": "multipart/form-data",
//           },
//         }
//       );

//       alert("Documents uploaded successfully!");
//     } catch (err) {
//       console.error("UPLOAD ERROR:", err.response?.data || err);
//       alert(err.response?.data?.message || "Upload failed");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const renderPreview = (file) => {
//     if (!file) return null;

//     if (file.type.startsWith("image/")) {
//       return <img src={URL.createObjectURL(file)} alt="preview" />;
//     }

//     return <p className="file-name">{file.name}</p>;
//   };

//   return (
//     <div className="doc-wrapper">
//       <div className="doc-card">
//         <h2>Upload Required Documents</h2>
//         <p>Please upload PAN Card & GST Certificate</p>

//         <form onSubmit={handleSubmit}>
//           {/* PAN */}
//           <div className="file-block">
//             <label>PAN Card</label>
//             <button type="button" onClick={() => panRef.current.click()}>
//               Choose PAN File
//             </button>
//             <input
//               ref={panRef}
//               type="file"
//               accept="image/*,.pdf"
//               hidden
//               onChange={(e) => setPan(e.target.files[0])}
//             />
//             {renderPreview(pan)}
//           </div>

//           {/* GST */}
//           <div className="file-block">
//             <label>GST Certificate</label>
//             <button type="button" onClick={() => gstRef.current.click()}>
//               Choose GST File
//             </button>
//             <input
//               ref={gstRef}
//               type="file"
//               accept="image/*,.pdf"
//               hidden
//               onChange={(e) => setGst(e.target.files[0])}
//             />
//             {renderPreview(gst)}
//           </div>

//           <button type="submit" disabled={loading}>
//             {loading ? "Uploading..." : "Submit Documents"}
//           </button>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default Documents;
import { useState, useRef } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import "../Styles/Documents.css";

const Documents = () => {
  // ✅ PHONE NUMBER FROM URL
  const { phoneNumber } = useParams();

  const [pan, setPan] = useState(null);
  const [gst, setGst] = useState(null);
  const [loading, setLoading] = useState(false);

  const panRef = useRef(null);
  const gstRef = useRef(null);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // ✅ validate phone number
    if (!phoneNumber) {
      alert("Invalid or expired upload link");
      return;
    }

    if (!pan || !gst) {
      alert("Please upload both PAN and GST documents.");
      return;
    }

    const formData = new FormData();
    formData.append("panFile", pan); // must match multer
    formData.append("gstFile", gst); // must match multer

    try {
      setLoading(true);

      await axios.post(
        `https://b2bbackendapi.mmstourism.com/api/b2/agency/upload-documents/${phoneNumber}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      alert("Documents uploaded successfully!");
    } catch (err) {
      console.error("UPLOAD ERROR:", err.response?.data || err);
      alert(err.response?.data?.message || "Upload failed");
    } finally {
      setLoading(false);
    }
  };

  const renderPreview = (file) => {
    if (!file) return null;

    if (file.type.startsWith("image/")) {
      return <img src={URL.createObjectURL(file)} alt="preview" />;
    }

    return <p className="file-name">{file.name}</p>;
  };

  return (
    <div className="doc-wrapper">
      <div className="doc-card">
        <h2>Upload Required Documents</h2>
        <p>Please upload PAN Card & GST Certificate</p>

        <form onSubmit={handleSubmit}>
          {/* PAN */}
          <div className="file-block">
            <label>PAN Card</label>
            <button type="button" onClick={() => panRef.current.click()}>
              Choose PAN File
            </button>
            <input
              ref={panRef}
              type="file"
              accept="image/*,.pdf"
              hidden
              onChange={(e) => setPan(e.target.files[0])}
            />
            {renderPreview(pan)}
          </div>

          {/* GST */}
          <div className="file-block">
            <label>GST Certificate</label>
            <button type="button" onClick={() => gstRef.current.click()}>
              Choose GST File
            </button>
            <input
              ref={gstRef}
              type="file"
              accept="image/*,.pdf"
              hidden
              onChange={(e) => setGst(e.target.files[0])}
            />
            {renderPreview(gst)}
          </div>

          <button type="submit" disabled={loading}>
            {loading ? "Uploading..." : "Submit Documents"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Documents;
